import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';
import { StakeholderType } from '@commenda/prisma';
import { useState } from 'react';
import RadioCardKS from '../../../../components/RadioCardKS';

const StakeholderOptionsModal = ({
  isShown,
  toggle,
  onShowCorporateShareholderModal,
  onShowDirectorModal,
  isMember = false,
}: {
  isShown: boolean;
  toggle: () => void;
  onShowDirectorModal: () => void;
  onShowCorporateShareholderModal: () => void;
  isMember?: boolean;
}) => {
  const [type, setType] = useState<StakeholderType>(StakeholderType.INDIVIDUAL);

  const title = isMember ? 'Select a member type' : 'Select a shareholder type';
  const description = isMember
    ? 'Choose the type of member to proceed.'
    : 'Choose the type of shareholder to proceed.';
  const individualHeading = isMember
    ? 'Individual Member'
    : 'Individual Shareholder';
  const individualDescription = isMember
    ? 'For private individuals such as founders, employees, or external investors.'
    : 'For private individuals such as founders, employees, or external investors.';
  const corporateHeading = isMember
    ? 'Corporate Member'
    : 'Corporate Shareholder';
  const corporateDescription = isMember
    ? 'For companies or legal entities acting as members.'
    : 'For companies or legal entities acting as shareholders.';

  return (
    <Dialog open={isShown} onOpenChange={toggle}>
      <DialogContent preventCloseOnOutsideClick>
        <DialogHeader className="flex flex-col items-start gap-1 pb-0 border-b-0">
          <DialogTitle className="txt-large-bold">{title}</DialogTitle>
          <p className="txt-small-regular">{description}</p>
        </DialogHeader>
        <div className="flex flex-col gap-3 px-6 pt-3 pb-5">
          <RadioCardKS
            heading={individualHeading}
            description={individualDescription}
            onClick={() => setType(StakeholderType.INDIVIDUAL)}
            isActive={type === StakeholderType.INDIVIDUAL}
          />
          <RadioCardKS
            heading={corporateHeading}
            description={corporateDescription}
            onClick={() => setType(StakeholderType.INSTITUTION)}
            isActive={type === StakeholderType.INSTITUTION}
          />
        </div>
        <DialogFooter>
          <Button size="sm" variant="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            size="sm"
            onClick={
              type === StakeholderType.INSTITUTION
                ? onShowCorporateShareholderModal
                : onShowDirectorModal
            }
          >
            Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default StakeholderOptionsModal;
